// 页面关闭开启提示
export const beforeUnloadMixin = {
  mounted() {
    window.addEventListener(
      "beforeunload",
      (this.$$beforeunloadMixin = (e) => {
        var dialogText = "false";
        e.preventDefault();
        e.returnValue = dialogText;
        return dialogText;
      })
    );
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.$$beforeunloadMixin);
  },
};
